import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';

export const SinglePaymentSuccessSnackbarMessage = () => {
  return (
    <Box display='flex' flexDirection='column' rowGap='2px'>
      <Typography variant='bodySmall' color={COLORS.grey[200]} fontWeight='medium'>
        Overage Wires Successfully Added.
      </Typography>
      <Typography variant='caption' color={COLORS.grey[200]} fontWeight='medium'>
        Thank you! Your purchase was successful. The invoice will be available in your billing records shortly.
      </Typography>
    </Box>
  );
};
